// removed by extract-text-webpack-plugin
module.exports = {"root":"_3uFUX","label":"_3qHss","content":"_2VmzO","highlight":"_PBIGo","name":"_wDkrJ","description":"_2wyDO","dropdown":"_2vwdX","price":"_1YXPK","symbol":"_2z-qD","quota":"_30EKz","number":"_jpdL1"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/TokenPack/TokenPack.scss
// module id = 1344
// module chunks = 3